import { render, staticRenderFns } from "./cModalMovement.vue?vue&type=template&id=8c480888&scoped=true"
import script from "./cModalMovement.vue?vue&type=script&lang=js"
export * from "./cModalMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c480888",
  null
  
)

export default component.exports